/**
 * <kashira-contact-form> — spec 09 b + the 17 System Feedback contract.
 *  - reveals the order-number field only when the Order topic is selected
 *  - defers ALL validation to window.KashiraFieldState so this form emits the
 *    same classes, helper markup, aria wiring AND copy as every other form:
 *    validate on blur, re-validate on input, focus the first invalid field on a
 *    failed submit, helper below the border box (never inside it)
 *  - a valid submit morphs the button label while the post is in flight
 * Reduced motion: no shake, the helper text still appears.
 */
class KashiraContactForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.topic = this.querySelector('[data-kashira-topic]');
    this.orderField = this.querySelector('[data-kashira-order-field]');
    this.submit = this.querySelector('[data-kashira-submit]');
    this.submitLabel = this.querySelector('[data-kashira-submit-label]');
    if (!this.form) return;

    this.orderTopic = (this.dataset.orderTopic || '').trim().toLowerCase();
    this.strings = window.kashiraContactStrings || {};
    this.fieldState = window.KashiraFieldState;

    if (this.topic && this.orderField) {
      this.topic.addEventListener('change', () => this.syncOrderField());
      this.syncOrderField();
    }

    // Only suppress the native bubbles when the shared layer is there to
    // replace them — otherwise the browser's own validation is better than none.
    if (this.fieldState) {
      this.form.setAttribute('novalidate', 'novalidate');
      // No `strings` override: field copy comes from the shared
      // window.kashiraFeedbackStrings bag so this form says exactly what the
      // newsletter, coupon and pincode say for the same failure. Passing this
      // section's own bag here shadowed it and gave contact a second wording.
      this.fieldState.bindLive(this.form);
    }
    this.form.addEventListener('submit', (event) => this.onSubmit(event));
  }

  syncOrderField() {
    const value = (this.topic.value || '').trim().toLowerCase();
    const show = this.orderTopic !== '' && value === this.orderTopic;
    this.orderField.hidden = !show;
    const input = this.orderField.querySelector('input');
    if (input && !show) input.value = '';
  }

  onSubmit(event) {
    if (this.fieldState && !this.fieldState.check(this.form)) {
      event.preventDefault();
      return;
    }

    if (this.submit) {
      this.submit.classList.add('is-sending');
      this.submit.setAttribute('aria-busy', 'true');
      if (this.submitLabel && this.strings.sending) this.submitLabel.textContent = this.strings.sending;
    }
  }
}

if (!customElements.get('kashira-contact-form')) {
  customElements.define('kashira-contact-form', KashiraContactForm);
}
